import request from './request'

// 微信接口相关
export const getWxConfig = params => request.post('/wx/getTicketSign.do', params)